module.exports = __webpack_public_path__ + "static/img/banner03.5ebc919.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/banner03.jpg
// module id = EphJ
// module chunks = 0